import {
  Monitor,
  Layers,
  Globe,
  Palette,
  Sparkles,
  Camera,
  Film,
} from 'lucide-react';

/**
 * Catálogo de productos Xperience.
 *
 * En producción esto debe migrar a la BD (tabla `productos` + `producto_variantes`
 * + `producto_addons`) para que el equipo pueda agregar productos sin redeploy.
 * Mientras Alejandro construye el endpoint, este archivo es la fuente de verdad.
 *
 * El campo `icon` es una referencia a lucide-react. En BD se guarda como string.
 */
export const CATALOGO = {
  clickXperience: {
    nombre: 'Click & Xperience',
    submarca: 'realEstate',
    icon: Monitor,
    descripcion:
      'Plataforma web interactiva con modelado 3D y sistema de gestión de disponibilidades',
    orden: 4,
  },
  showroomSoftware: {
    nombre: 'Showroom - Software',
    submarca: 'realEstate',
    icon: Layers,
    descripcion: 'Experiencia showroom completa tipo ALORA/Viento Nuevo',
    orden: 5,
    fases: {
      modelado3d: {
        label: 'Fase 1: Modelado y Levantamiento 3D',
        precio: 198375,
      },
      entregables: {
        label: 'Fase 2: Entregables a partir de 3D',
        precio: 293400,
      },
      programacion: {
        label: 'Fase 3: Programación Click & Xperience',
        precio: 230500,
      },
    },
  },
  plataformaMadre: {
    nombre: 'Plataforma Madre / Portafolio Digital',
    submarca: 'realEstate',
    icon: Globe,
    descripcion: 'Ecosistema digital que centraliza múltiples proyectos',
    orden: 3,
    variantes: [
      { id: 'horizontal', label: 'Plataforma completa (nueva)', precio: 80000 },
      { id: 'integracion', label: 'Integración de verticales', precio: 32000 },
    ],
  },
  landingXperience: {
    nombre: 'Landing Xperience',
    submarca: 'group',
    icon: Globe,
    descripcion: 'Landing con portafolio dinámico y direccionamiento a C&X',
    orden: 2,
    precio: 96500,
  },
  landing: {
    nombre: 'Landing / Sitio Web',
    submarca: 'group',
    icon: Globe,
    descripcion: 'Landing básica, avanzada o sitio completo',
    orden: 2,
    variantes: [
      { id: 'basica', label: 'Landing básica (1 sección)', precio: 15000 },
      { id: 'avanzada', label: 'Landing avanzada (varias secciones)', precio: 22500 },
      { id: 'completa', label: 'Sitio completo (múltiples páginas)', precio: 40000 },
    ],
    addons: {
      scroll3d: { label: '3D Scroll', precio: 5000 },
      ecommerce: { label: 'E-commerce', precio: 10000 },
      blog: { label: 'Blog', precio: 6500 },
      seo: { label: 'SEO avanzado', precio: 5000 },
    },
  },
  identidad: {
    nombre: 'Identidad de Marca',
    submarca: 'group',
    icon: Palette,
    descripcion: 'Identidad visual, verbal y estratégica',
    orden: 1,
    variantes: [
      { id: 'logo', label: 'Logo + paleta', precio: 10500 },
      { id: 'basica', label: 'Identidad básica', precio: 35000 },
      { id: 'completa', label: 'Identidad completa', precio: 45000 },
    ],
    addons: {
      papeleria: { label: 'Papelería corporativa', precio: 3000 },
      plantillas: { label: 'Plantillas de comunicación', precio: 5000 },
      impresos: { label: 'Materiales impresos', precio: 5000 },
      senaletica: { label: 'Señalética / ambientación', precio: 15000 },
    },
  },
  rendersHyper: {
    nombre: 'Renders Hiperrealistas',
    submarca: 'realEstate',
    icon: Sparkles,
    descripcion: 'Renders de alta resolución para comercialización',
    orden: 6,
    base: {
      adaptacion: { label: 'Adaptación de modelo', precio: 45000 },
      texturizado: { label: 'Texturizado', precio: 20000 },
    },
    porUnidad: {
      exterior: { label: 'Render exterior', precio: 8500 },
      interior: { label: 'Render interior', precio: 6000 },
    },
  },
  produccionAV: {
    nombre: 'Producción Audiovisual',
    submarca: 'media',
    icon: Camera,
    descripcion: 'Paquetes cerrados de producción de video',
    orden: 7,
    variantes: [
      { id: 'comercial-basico', label: 'Comercial básico (1 día)', precio: 14900 },
      { id: 'comercial-completo', label: 'Comercial completo (con drone y voz)', precio: 32900 },
      { id: 'institucional', label: 'Video institucional (2 días)', precio: 82900 },
      { id: 'documental', label: 'Documental / entrevista (2 días)', precio: 87600 },
    ],
  },
  produccionXRE: {
    nombre: 'Producción Inmobiliaria (Obra)',
    submarca: 'realEstate',
    icon: Camera,
    descripcion: 'Producción audiovisual y seguimiento de obra',
    orden: 8,
    variantes: [
      { id: 'tipologia', label: 'Edición + levantamiento de tipología', precio: 24350 },
      { id: 'nave', label: 'Edición + levantamiento de nave', precio: 27950 },
      { id: 'seg-completo', label: 'Seguimiento de obra (drone + piso)', precio: 20050 },
      { id: 'seg-drone', label: 'Seguimiento de obra (solo drone)', precio: 16600 },
    ],
  },
  contenido: {
    nombre: 'Generación de Contenido',
    submarca: 'media',
    icon: Film,
    descripcion: 'Producción mensual/bimestral para redes sociales',
    orden: 9,
    variantes: [
      { id: 'edicion', label: 'Solo edición', precio: 8250, periodo: 'mensual' },
      { id: 'bim-2hrs', label: 'Bimestral 2hrs producción', precio: 21450, periodo: 'bimestral' },
      { id: 'bim-mediodia', label: 'Bimestral medio día', precio: 30900, periodo: 'bimestral' },
    ],
  },
};

export const ESQUEMAS_PAGO = [
  { id: '12-iguales', label: '12 igualas mensuales iguales' },
  { id: 'iguala-mayor', label: 'Pago inicial mayor + 11 igualas' },
  { id: '40-30-30', label: '40% anticipo / 30% avance / 30% finiquito' },
  { id: '50-50', label: '50% anticipo / 50% finiquito' },
  { id: 'anticipo-12m', label: 'Anticipo 40% + 12 igualas' },
  { id: 'bimestral', label: 'Bimestral (contenido)' },
  { id: 'por-avance', label: 'Por avance / estimaciones' },
  { id: 'custom', label: 'Custom' },
];
